import { getStrings } from '/Scripts/modules/strings.js';
import { getUserFlags, getSARFlags, getApplicationStrings, getUserSettings, getFeatureFlags } from '/Scripts/modules/settings.js';

const ExploreContext = React.createContext([{}, () => { }]);

const ExploreProvider = ({ children = null, isAuthenticated = true }) => {
	const [state, setState] = React.useState({});

	const fetchStrings = async () => {
		let result = await getStrings();
		setState(state => ({ ...state, resources: result }));
	}
	const fetchUserFlags = async () => {
		let result = await getUserFlags();
		setState(state => ({ ...state, settings: { ...state.settings, ...result } }));
	}
	const fetchSARFlags = async () => {
		let result = await getSARFlags();
		setState(state => ({ ...state, settings: { ...state.settings, ...result } }));
	}
	const fetchApplicationStrings = async () => {
		let result = await getApplicationStrings();
		setState(state => ({ ...state, settings: { ...state.settings, ...result } }));
	}
	const fetchUserSettings = async () => {
		let result = await getUserSettings();
		setState(state => ({ ...state, settings: { ...state.settings, ...result } }));
	}
	const fetchFeatureFlags = async () => {
		let result = await getFeatureFlags();
		setState(state => ({ ...state, settings: { ...state.settings, featureFlags: result } }));
	}

	React.useEffect(() => {
		fetchStrings();
		if (isAuthenticated) {
			fetchUserFlags();
			fetchSARFlags();
			fetchApplicationStrings();
			fetchUserSettings();
			fetchFeatureFlags();
		}
	}, []);

	if (state.resources === undefined)
		return null;

	return (
		<ExploreContext.Provider value={[state, setState]}>
			{children}
		</ExploreContext.Provider>
	);
}

export { ExploreContext, ExploreProvider };